import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.104 3.5a1 1 0 0 1 .995.89l.012.11.112 1 .11 1 .568 5.11a1 1 0 0 0 .995.89H9a2 2 0 0 1 1.999 1.929q.002.071.01.141L12 21.5h-2l-.938-6.57a.5.5 0 0 0-.496-.43H3.5a.5.5 0 0 0-.5.5v6.5H1v-9l-1-9zM19 10.5v9a2 2 0 0 1 2 2h-6a2 2 0 0 1 2-2v-9zm4-3a1 1 0 0 1 1 1v1H12v-1a1 1 0 0 1 1-1z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })